module.exports = __webpack_public_path__ + "static/media/thetagocld.384e8905.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thetagocld.png
// module id = 453
// module chunks = 0